import AppView from './app-view';

export default AppView;
